export default {"src":"/_next/static/media/chess.abc7b33b.svg","height":400,"width":300};